import { composeRight } from "./fpUtils";
import { Func1 } from "redux";

const get = require("lodash/get");

export const forSelector = <S, T>(selector: Func1<S, T>) => ({
    addPath: <T>(path: string[], def = null as T): Func1<S, T> =>
        composeRight(selector, sub => get(sub, path, def)),
});

export function isObjectPropsEquals(a, b) {
    if (!a || !b) return false;

    const aProps = Object.keys(a);
    const bProps = Object.keys(b);
    if (aProps.length !== bProps.length) return false;

    const bSet = new Set(bProps);
    for (let prop of aProps) {
        bSet.delete(prop);
        if (a[prop] !== b[prop]) return false;
    }

    return bSet.size === 0;
}
